// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + __webpack_require__.h().slice(0, 8) + ".min.css";
};